import { FC } from 'react';

export const CollectIn: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 10.25C12.5523 10.25 13 10.6977 13 11.25V14.3358L14.2929 13.0429C14.6834 12.6524 15.3166 12.6524 15.7071 13.0429C16.0976 13.4334 16.0976 14.0666 15.7071 14.4571L12.7071 17.4571C12.5196 17.6446 12.2652 17.75 12 17.75C11.7348 17.75 11.4804 17.6446 11.2929 17.4571L8.29289 14.4571C7.90237 14.0666 7.90237 13.4334 8.29289 13.0429C8.68342 12.6524 9.31658 12.6524 9.70711 13.0429L11 14.3358V11.25C11 10.6977 11.4477 10.25 12 10.25Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.17279 4.65836C3.68096 3.64201 4.71975 3 5.85607 3H18.1439C19.2802 3 20.319 3.64201 20.8272 4.65836L21.6833 6.37049C21.8916 6.78706 22 7.2464 22 7.71214V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V7.71214C2 7.2464 2.10844 6.78706 2.31672 6.37049L3.17279 4.65836ZM5.85607 5C5.4773 5 5.13103 5.214 4.96164 5.55279L4.23803 7H19.762L19.0384 5.55279C18.869 5.214 18.5227 5 18.1439 5H5.85607ZM20 9H4V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V9Z"
			fill="currentColor"
		/>
	</svg>
);
